module.exports = __webpack_public_path__ + "static/media/call.00415427.svg";